module.exports = "/_next/static/media/2380a58b4d1d8f7a0df3eb791c5e59d4.svg";